app.controller('Accomodation', function ($scope) {
	$scope.items = {};
});